<template>
  <HeaderPopup v-bind:onCloseClick="onCloseClick" v-bind:toggleButtonRef="toggleButtonRef">
    <div class="currencies-block">
      <HeaderPopupTitle class="currencies-title">Select Currency</HeaderPopupTitle>
      <div class="currencies-block__list">
        <HeaderPopupListItem
          v-bind:key="c.label"
          v-for="c in currencies"
          v-bind:onClick="() => selectCurrency(c.label)"
          v-bind:class="{
            'currencies-list__content': true,
            'currencies-list__content--active': currency === c.label
          }"
        >
          <div class="currencies-list__circle">
            <span>{{ c.label }}</span>
          </div>
          <div class="currencies-list__name">
            {{ c.name }}
          </div>
        </HeaderPopupListItem>
        <div class="currencies-block__input-block" v-if="!isPresentation">
          <input type="text" v-model="customCurrency" placeholder="Custom Currency" />
          <button @click="() => selectCurrency(this.customCurrency.toUpperCase())">OK</button>
        </div>
      </div>
    </div>
  </HeaderPopup>
</template>

<script>
import { mapState } from "vuex";
import HeaderPopup from "./header/HeaderPopup";
import HeaderPopupListItem from "./HeaderPopupListItem";
import HeaderPopupTitle from "./HeaderPopupTitle";
import currencies from "../constants/currencies";

export default {
  components: {
    HeaderPopupTitle,
    HeaderPopupListItem,
    HeaderPopup,
  },
  props: {
    onCloseClick: Function,
    toggleButtonRef: HTMLElement,
  },
  name: "CurrencySelect",
  data() {
    return {
      customCurrency: '',
      currencies,
    }
  },
  computed: {
    ...mapState("auth", ["currency"]),
    ...mapState("app", ["isPresentation"]),
  },
  methods: {
    selectCurrency(currency) {
      if(this.isPresentation) {
        this.$store.dispatch("auth/selectCurrency", currency).then(() => this.$store.dispatch("balance/addMoney", { amount: 1000000000000 }));
      } else {
        this.$store.dispatch("auth/selectCurrency", currency);
      }
    },
  },
};
</script>

<style scoped>
.currencies-block {
  width: 280px;
  box-sizing: border-box;
}
.currencies-title {
  margin: 0 16px 12px;
}
.currencies-block__list {
  overflow-y: auto;
  max-height: 320px;
}
.currencies-list__content {
  display: flex;
  justify-content: flex-start;
  padding: 0 16px;
  margin-bottom: 8px;
  width: inherit;
  font-size: 12px;
  line-height: 13px;
  font-weight: 600;

}
.currencies-list__content--active .currencies-list__circle {
  border-color: #1132EC;
}
.currencies-list__circle {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.05);
  border: 2px solid transparent;
}

.currencies-list__name {
  margin-left: 12px;
  text-transform: uppercase;
}
.currencies-block__input-block {
  display: flex;
  align-items: center;
  font-size: 12px;
  background: none;
  margin: 16px 0;
}
.currencies-block input {
  height: 24px;
  flex: 1;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  padding: 0 8px;
  background: #ffffff;
  font-weight: 600;
}
.currencies-block button {
  border: none;
  flex: 0 0 auto;
  height: 24px;
  border-radius: 6px;
  color: #fff;
  background: #0f71f3;
  margin-left: 8px;
  font-weight: 600;
}
@media (max-width: 600px) {
  .currencies-block {
    width: 100%;
  }
}
</style>
